import BackboneElement from './BackboneElement';
import merge from 'lodash/merge';
import Coding from './types/Coding';

export default class BN_Adjustment extends BackboneElement {
    static __className = 'BN_Adjustment';

    __objectStructure = {
        amount: Number,
        CARCode: Coding,
        CARCodeCategory: Coding,
    };

    constructor(constructJson, className = 'BN_Adjustment') {
        super(constructJson, className);
        this.createAndPopulateStructure(this.__objectStructure, constructJson);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
